import React from "react";

export default ({ ...props }) => {
  return (
    <svg
      width="201px"
      height="104px"
      viewBox="0 0 201 104"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Other Applications</title>
      <defs>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="oa-linearGradient-1"
        >
          <stop stopColor="#4B82B6" offset="0%"></stop>
          <stop stopColor="#355F86" offset="100%"></stop>
        </linearGradient>
        <path d="M3,1 L3,201" id="oa-path-2"></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="oa-linearGradient-3"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M107.875,2.113 C108.42578,2.113 108.875,2.55831 108.875,3.113 L108.875,8.866 L113.15297,4.58993 C113.54359,4.19931 114.17637,4.19931 114.56707,4.58993 C114.95777,4.98055 114.95769,5.61333 114.56707,6.00403 L110.291,10.28 L116.043,10.281 C116.59378,10.281 117.043,10.72631 117.043,11.281 C117.043,11.83569 116.59378,12.281 116.043,12.281 L110.534,12.28 L114.56607,16.31293 C114.95669,16.70355 114.95669,17.33633 114.56607,17.72703 C114.37076,17.92234 114.11295,18.02 113.85904,18.02 C113.60119,18.02 113.34728,17.92234 113.15197,17.72703 L108.875,13.451 L108.875,19.449 C108.875,20.00369 108.42578,20.449 107.875,20.449 C107.32422,20.449 106.875,20.00369 106.875,19.449 L106.875,13.696 L102.84407,17.72703 C102.64876,17.92234 102.39095,18.02 102.13704,18.02 L102.136998,18.02 C101.87919,18.02 101.62528,17.92234 101.42997,17.72703 C101.03934,17.33641 101.03934,16.70363 101.42997,16.31293 L105.461,12.28 L99.707,12.281 C99.15622,12.281 98.707,11.83569 98.707,11.281 C98.707,10.72631 99.15622,10.281 99.707,10.281 L105.704,10.28 L101.42897,6.00403 C101.03834,5.61341 101.03834,4.98063 101.42897,4.58993 C101.81959,4.19931 102.45237,4.19931 102.84307,4.58993 L106.875,8.621 L106.875,3.113 C106.875,2.55831 107.32422,2.113 107.875,2.113 Z"
          id="oa-path-4"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="oa-linearGradient-5"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M132.129,24.391 C132.67978,24.391 133.129,24.83631 133.129,25.391 L133.128,33.12 L138.59797,27.65193 C138.98859,27.26131 139.62137,27.26131 140.01207,27.65193 C140.40277,28.04255 140.40269,28.67533 140.01207,29.06603 L134.543,34.535 L142.277,34.535 C142.82778,34.535 143.277,34.98031 143.277,35.535 C143.277,36.08969 142.82778,36.535 142.277,36.535 L134.544,36.535 L140.01207,42.00393 C140.40269,42.39455 140.40269,43.02733 140.01207,43.41803 C139.81676,43.61334 139.56285,43.711 139.30504,43.711 L139.305,43.711 C139.04719,43.711 138.79328,43.61334 138.59797,43.41803 L133.128,37.949 L133.129,45.688 C133.129,46.23488 132.68369,46.68409 132.129,46.68409 C131.57822,46.68409 131.129,46.23869 131.129,45.684 L131.128,37.95 L125.66007,43.41803 C125.46476,43.61334 125.21085,43.711 124.95304,43.711 C124.69519,43.711 124.44128,43.61334 124.24597,43.41803 C123.85535,43.02741 123.85535,42.39463 124.24597,42.00393 L129.713,36.535 L121.98,36.535 C121.42922,36.535 120.98,36.08969 120.98,35.535 C120.98,34.98031 121.42922,34.535 121.98,34.535 L129.714,34.535 L124.24597,29.06603 C123.85535,28.67541 123.85535,28.04263 124.24597,27.65193 C124.63659,27.26123 125.26937,27.26131 125.66007,27.65193 L131.128,33.119 L131.129,25.391 C131.129,24.83631 131.57822,24.391 132.129,24.391 Z"
          id="oa-path-6"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="99.6199324%"
          id="oa-linearGradient-7"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M123.074,58.929 C123.90212,58.929 124.574,59.60087 124.574,60.429 L124.574,70.386 L131.5515,63.4094 C132.13744,62.82346 133.0867,62.82346 133.6726,63.4094 C134.25854,63.99534 134.25854,64.9446 133.6726,65.5305 L126.758,72.444 L136.336,72.445 C137.16412,72.445 137.836,73.11688 137.836,73.945 C137.836,74.77313 137.16412,75.445 136.336,75.445 L126.647,75.444 L133.6716,82.4684 C134.25754,83.05434 134.25754,84.0036 133.6716,84.5895 C133.37863,84.88247 132.99582,85.027 132.613,85.027 C132.23019,85.027 131.84347,84.88247 131.5505,84.5895 L124.574,77.613 L124.574,87.655998 C124.574,88.484118 123.90603,89.155998 123.074,89.155998 C122.24588,89.155998 121.574,88.484118 121.574,87.655998 L121.574,77.628 L114.6136,84.5895 C114.32063,84.88247 113.93782,85.027 113.555,85.027 C113.17219,85.027 112.78547,84.88247 112.4925,84.5895 C111.90656,84.00356 111.90656,83.0543 112.4925,82.4684 L119.516,75.444 L109.606,75.445 C108.77788,75.445 108.106,74.77313 108.106,73.945 C108.106,73.11688 108.77788,72.445 109.606,72.445 L119.405,72.444 L112.4915,65.5305 C111.90556,64.94456 111.90556,63.9953 112.4915,63.4094 C113.07744,62.82346 114.0267,62.82346 114.6126,63.4094 L121.574,70.371 L121.574,60.429 C121.574,59.60087 122.24588,58.929 123.074,58.929 Z"
          id="oa-path-8"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="oa-linearGradient-9"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M80.6445,4.343 C76.1523,4.343 72.4961,7.9524 72.4961,12.3938 L72.4961,51.9098 C72.4961,52.58558 72.15626,53.2145 71.58985,53.5856 C66.66405,56.8004 63.72265,62.2536 63.72265,68.1716 C63.72265,77.695 71.51175,85.444603 81.08165,85.444603 C90.58945,85.444603 98.32365,77.6946 98.32365,68.1716 C98.32365,62.156 95.04635,56.4486 89.76505,53.2846 C89.16349,52.92522 88.79239,52.2729 88.79239,51.5698 L88.7963,12.3938 C88.7963,7.9563 85.1401,4.343 80.644,4.343 L80.6445,4.343 Z"
          id="oa-path-10"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="oa-linearGradient-11"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M73.3483986,58.4572783 C73.9341851,59.0430647 73.9341851,59.9928122 73.3483986,60.5785986 C71.3894467,62.5375505 70.27,65.1807854 70.27,68.0002 C70.27,70.8196146 71.3894467,73.4628495 73.3483986,75.4218014 C73.9341851,76.0075878 73.9341851,76.9573353 73.3483986,77.5431217 C72.7626122,78.1289082 71.8128647,78.1289082 71.2270783,77.5431217 C68.7114366,75.02748 67.27,71.6239635 67.27,68.0002 C67.27,64.3764365 68.7114366,60.97292 71.2270783,58.4572783 C71.8128647,57.8714918 72.7626122,57.8714918 73.3483986,58.4572783 Z M80.77,39.758 C81.5984271,39.758 82.27,40.4295729 82.27,41.258 L82.2709776,62.9577393 C84.3488022,63.5651919 85.87,65.4882571 85.87,67.758 C85.87,70.5160684 83.6280684,72.758 80.87,72.758 C78.1119316,72.758 75.87,70.5160684 75.87,67.758 C75.87,65.5592086 77.2948867,63.6884542 79.270228,63.020169 L79.27,41.258 C79.27,40.4295729 79.9415729,39.758 80.77,39.758 Z M89.602,40.895 C90.15278,40.895 90.602,41.34031 90.602,41.895 C90.602,42.44969 90.15669,42.895 89.602,42.895 L84.7895,42.895 C84.23872,42.895 83.7895,42.44969 83.7895,41.895 C83.7895,41.34031 84.23872,40.895 84.7895,40.895 L89.602,40.895 Z M89.602,35.121 C90.15278,35.121 90.602,35.56631 90.602,36.121 C90.602,36.67178 90.15669,37.121 89.602,37.121 L84.7895,37.121 C84.23872,37.121 83.7895,36.67569 83.7895,36.121 C83.7895,35.56631 84.23872,35.121 84.7895,35.121 L89.602,35.121 Z M89.602,29.664 C90.15278,29.664 90.602,30.10931 90.602,30.664 C90.602,31.21869 90.15669,31.664 89.602,31.664 L84.7895,31.664 C84.23872,31.664 83.7895,31.21869 83.7895,30.664 C83.7895,30.10931 84.23872,29.664 84.7895,29.664 L89.602,29.664 Z M89.602,24.211 C90.15278,24.211 90.602,24.65631 90.602,25.211 C90.602,25.76569 90.15669,26.211 89.602,26.211 L84.7895,26.211 C84.23872,26.211 83.7895,25.76569 83.7895,25.211 C83.7895,24.65631 84.23872,24.211 84.7895,24.211 L89.602,24.211 Z M89.602,18.758 C90.15278,18.758 90.602,19.20331 90.602,19.758 C90.602,20.30878 90.15669,20.758 89.602,20.758 L84.7895,20.758 C84.23872,20.758 83.7895,20.31269 83.7895,19.758 C83.7895,19.20331 84.23872,18.758 84.7895,18.758 L89.602,18.758 Z"
          id="oa-path-12"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="oa-linearGradient-13"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M80.6444,0.344 C87.3432,0.344 92.7924,5.7502 92.7924,12.395 L92.7924,50.473 C98.6986,54.4535 102.3236,61.133 102.3236,68.172 C102.3236,79.899 92.7963,89.442001 81.0816,89.442001 L81.082,89.441002 C69.305,89.441002 59.723001,79.898 59.723001,68.168 C59.723001,61.2618 62.9847,54.871 68.4964,50.856 L68.4964,12.395 C68.4964,5.7505 73.9456,0.344 80.6444,0.344 Z M80.644001,4.342 C76.1523,4.343 72.4961,7.9524 72.4961,12.3938 L72.4961,51.9098 C72.4961,52.58558 72.15626,53.2145 71.58985,53.5856 C66.66405,56.8004 63.72265,62.2536 63.72265,68.1716 C63.72265,77.695 71.51175,85.444603 81.08165,85.444603 C90.58945,85.444603 98.32365,77.6946 98.32365,68.1716 C98.32365,62.156 95.04635,56.4486 89.76505,53.2846 C89.16349,52.92522 88.79239,52.2729 88.79239,51.5698 L88.7963,12.3938 C88.7963,8.03847593 85.274261,4.47710857 80.8929014,4.34669967 L80.644001,4.342 Z"
          id="oa-path-14"
        ></path>
      </defs>
      <g
        id="oa-Wireframe-v4-Layout-v2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="oa-PWA-Desktop-Page0---Home"
          transform="translate(-870.000000, -491.000000)"
        >
          <g id="oa-Group-4" transform="translate(320.000000, 426.000000)">
            <g id="oa-Group-2-Copy" transform="translate(500.000000, 0.000000)">
              <g id="oa-Group" transform="translate(40.000000, 50.000000)">
                <g id="oa-Group-22" transform="translate(9.000000, 15.000000)">
                  <g
                    id="oa-Group-2"
                    transform="translate(101.000000, 99.200000) rotate(90.000000) translate(-101.000000, -99.200000) translate(98.000000, -1.800000)"
                  >
                    <g id="oa-Path-3">
                      <use
                        stroke="url(#oa-linearGradient-1)"
                        strokeWidth="9"
                        href="#oa-path-2"
                      ></use>
                      <use
                        stroke="#FFFFFF"
                        strokeWidth="5"
                        href="#oa-path-2"
                      ></use>
                    </g>
                    <line
                      x1="-3"
                      y1="32.9446895"
                      x2="7.94468953"
                      y2="22"
                      id="oa-Path-6"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="27.5"
                      x2="7.94468953"
                      y2="16.5553105"
                      id="oa-Path-6-Copy-37"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="22.5"
                      x2="7.94468953"
                      y2="11.5553105"
                      id="oa-Path-6-Copy-38"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="17.5"
                      x2="7.94468953"
                      y2="6.55531047"
                      id="oa-Path-6-Copy-39"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="12.5"
                      x2="7.94468953"
                      y2="1.55531047"
                      id="oa-Path-6-Copy-40"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="7.5"
                      x2="7.94468953"
                      y2="-3.44468953"
                      id="oa-Path-6-Copy-41"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="37.8893791"
                      x2="7.94468953"
                      y2="26.9446895"
                      id="oa-Path-6-Copy"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="42.8893791"
                      x2="7.94468953"
                      y2="31.9446895"
                      id="oa-Path-6-Copy-2"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="47.8893791"
                      x2="7.94468953"
                      y2="36.9446895"
                      id="oa-Path-6-Copy-3"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="52.8893791"
                      x2="7.94468953"
                      y2="41.9446895"
                      id="oa-Path-6-Copy-4"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="57.8893791"
                      x2="7.94468953"
                      y2="46.9446895"
                      id="oa-Path-6-Copy-5"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="62.8893791"
                      x2="7.94468953"
                      y2="51.9446895"
                      id="oa-Path-6-Copy-6"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="67.8893791"
                      x2="7.94468953"
                      y2="56.9446895"
                      id="oa-Path-6-Copy-7"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="72.8893791"
                      x2="7.94468953"
                      y2="61.9446895"
                      id="oa-Path-6-Copy-8"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="77.8893791"
                      x2="7.94468953"
                      y2="66.9446895"
                      id="oa-Path-6-Copy-9"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="82.8893791"
                      x2="7.94468953"
                      y2="71.9446895"
                      id="oa-Path-6-Copy-10"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="87.8893791"
                      x2="7.94468953"
                      y2="76.9446895"
                      id="oa-Path-6-Copy-11"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="92.8893791"
                      x2="7.94468953"
                      y2="81.9446895"
                      id="oa-Path-6-Copy-12"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="97.8893791"
                      x2="7.94468953"
                      y2="86.9446895"
                      id="oa-Path-6-Copy-13"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="102.889379"
                      x2="7.94468953"
                      y2="91.9446895"
                      id="oa-Path-6-Copy-14"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="107.889379"
                      x2="7.94468953"
                      y2="96.9446895"
                      id="oa-Path-6-Copy-15"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="112.889379"
                      x2="7.94468953"
                      y2="101.94469"
                      id="oa-Path-6-Copy-16"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="117.889379"
                      x2="7.94468953"
                      y2="106.94469"
                      id="oa-Path-6-Copy-17"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="122.889379"
                      x2="7.94468953"
                      y2="111.94469"
                      id="oa-Path-6-Copy-18"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="127.889379"
                      x2="7.94468953"
                      y2="116.94469"
                      id="oa-Path-6-Copy-19"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="132.889379"
                      x2="7.94468953"
                      y2="121.94469"
                      id="oa-Path-6-Copy-20"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="137.889379"
                      x2="7.94468953"
                      y2="126.94469"
                      id="oa-Path-6-Copy-21"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="142.889379"
                      x2="7.94468953"
                      y2="131.94469"
                      id="oa-Path-6-Copy-22"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="147.889379"
                      x2="7.94468953"
                      y2="136.94469"
                      id="oa-Path-6-Copy-23"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="152.889379"
                      x2="7.94468953"
                      y2="141.94469"
                      id="oa-Path-6-Copy-24"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="157.889379"
                      x2="7.94468953"
                      y2="146.94469"
                      id="oa-Path-6-Copy-25"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="162.889379"
                      x2="7.94468953"
                      y2="151.94469"
                      id="oa-Path-6-Copy-26"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="167.889379"
                      x2="7.94468953"
                      y2="156.94469"
                      id="oa-Path-6-Copy-27"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="172.889379"
                      x2="7.94468953"
                      y2="161.94469"
                      id="oa-Path-6-Copy-28"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="177.889379"
                      x2="7.94468953"
                      y2="166.94469"
                      id="oa-Path-6-Copy-29"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="182.889379"
                      x2="7.94468953"
                      y2="171.94469"
                      id="oa-Path-6-Copy-30"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="187.889379"
                      x2="7.94468953"
                      y2="176.94469"
                      id="oa-Path-6-Copy-31"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="192.889379"
                      x2="7.94468953"
                      y2="181.94469"
                      id="oa-Path-6-Copy-32"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="197.889379"
                      x2="7.94468953"
                      y2="186.94469"
                      id="oa-Path-6-Copy-33"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="202.889379"
                      x2="7.94468953"
                      y2="191.94469"
                      id="oa-Path-6-Copy-34"
                      stroke="#01AEEF"
                    ></line>
                    <line
                      x1="-3"
                      y1="207.889379"
                      x2="7.94468953"
                      y2="196.94469"
                      id="oa-Path-6-Copy-35"
                      stroke="#01AEEF"
                    ></line>
                  </g>
                  <g id="oa-Combined-Shape">
                    <use fill="#8FD5EF" href="#oa-path-4"></use>
                    <use
                      fill="url(#oa-linearGradient-3)"
                      style={{ mixBlendMode: "screen" }}
                      href="#oa-path-4"
                    ></use>
                  </g>
                  <g id="oa-Combined-Shape">
                    <use fill="#00AEEF" href="#oa-path-6"></use>
                    <use
                      fill="url(#oa-linearGradient-5)"
                      style={{ mixBlendMode: "screen" }}
                      href="#oa-path-6"
                    ></use>
                  </g>
                  <g id="oa-Combined-Shape">
                    <use fill="#487FB4" href="#oa-path-8"></use>
                    <use
                      fillOpacity="0.5"
                      fill="url(#oa-linearGradient-7)"
                      style={{ mixBlendMode: "multiply" }}
                      href="#oa-path-8"
                    ></use>
                  </g>
                  <g id="oa-Path">
                    <use fill="#8FD5EF" href="#oa-path-10"></use>
                    <use
                      fill="url(#oa-linearGradient-9)"
                      style={{ mixBlendMode: "screen" }}
                      href="#oa-path-10"
                    ></use>
                  </g>
                  <g id="oa-Combined-Shape">
                    <use fill="#00AEEF" href="#oa-path-12"></use>
                    <use
                      fill="url(#oa-linearGradient-11)"
                      style={{ mixBlendMode: "screen" }}
                      href="#oa-path-12"
                    ></use>
                  </g>
                  <g id="oa-Combined-Shape">
                    <use fill="#00AEEF" href="#oa-path-14"></use>
                    <use
                      fill="url(#oa-linearGradient-13)"
                      style={{ mixBlendMode: "screen" }}
                      href="#oa-path-14"
                    ></use>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
